// extracted by mini-css-extract-plugin
module.exports = {"totop":"totop--3epJ5H","active":"active--18g7T0","detailpage":"detailpage--12bPpm"};